// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ServiceabilitySession from "./ServiceabilitySession.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sessions = Decco.optionFromJson((function (param) {
          return Decco.listFromJson(ServiceabilitySession.t_decode, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "sessions"), null));
  if (sessions.TAG === /* Ok */0) {
    var offset_value = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset_value"), null));
    if (offset_value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                sessions: sessions._0,
                offset_value: offset_value._0
              }
            };
    }
    var e = offset_value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".offset_value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = sessions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sessions" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  t_decode ,
  
}
/* ServiceabilitySession Not a pure module */
